/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  ConsoleInstanceFunnelbackHostingType,
  CONSOLE_INSTANCE_FUNNELBACK_HOSTING_TYPE_DEDICATED,
  CONSOLE_INSTANCE_FUNNELBACK_HOSTING_TYPE_MULTI_TENANTED,
  CONSOLE_INSTANCE_FUNNELBACK_HOSTING_TYPE_SAAS,
} from './ConsoleFunnelbackInstance.entity.constant';

/**
 * All of the possible `CONSOLE_INSTANCE_FUNNELBACK_HOSTING_TYPE_*`'s.
 * @export
 */
export const CONSOLE_INSTANCE_FUNNELBACK_HOSTING_TYPES: ReadonlyArray<ConsoleInstanceFunnelbackHostingType> = [
  CONSOLE_INSTANCE_FUNNELBACK_HOSTING_TYPE_DEDICATED,
  CONSOLE_INSTANCE_FUNNELBACK_HOSTING_TYPE_MULTI_TENANTED,
  CONSOLE_INSTANCE_FUNNELBACK_HOSTING_TYPE_SAAS,
];
